export type PaymentProduct = "event_access_unlock" | "event_vip_unlock" | "default";

const DEFAULT_CONTINUE_BY_PRODUCT: Record<PaymentProduct, string> = {
  default: "/discover",
  event_access_unlock: "/discover",
  event_vip_unlock: "/liked-you",
};

export function defaultContinuePathForProduct(product: PaymentProduct): string {
  return DEFAULT_CONTINUE_BY_PRODUCT[product];
}

export function buildPaymentSuccessPath(params: {
  product: PaymentProduct;
  amountPence: number;
  next?: string;
  unlockPending?: boolean;
}): string {
  const search = new URLSearchParams({
    product: params.product,
    amount: String(params.amountPence),
    date: new Date().toISOString(),
  });
  const next = params.next ?? defaultContinuePathForProduct(params.product);
  search.set("next", next);
  if (params.unlockPending) {
    search.set("unlock", "pending");
  }
  return `/payment-success?${search.toString()}`;
}

export function buildPaymentFailedPath(params: {
  amountPence: number;
  product?: PaymentProduct;
  next?: string;
  error?: string;
}): string {
  const product = params.product ?? "default";
  const search = new URLSearchParams({
    amount: String(params.amountPence),
    product,
  });
  search.set("next", params.next ?? defaultContinuePathForProduct(product));
  if (params.error?.trim()) {
    search.set("error", params.error.trim().slice(0, 200));
  }
  return `/payment-failed?${search.toString()}`;
}
